module.exports = __webpack_public_path__ + "static/media/branding.011f5220.svg";


//////////////////
// WEBPACK FOOTER
// ./src/branding.svg
// module id = 285
// module chunks = 0